import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Button } from '@gem/ui-kit';

import {
  IScheduledCallCreatePopupParams,
  useScheduledCallCreatePopupPresenter,
} from './ScheduledCallSuccessPopup.presenter';
import styles from './ScheduledCallSuccessPopup.styles.m.css';

export const ScheduledCallSuccessPopup: FC<ICommonPopupsProps<IScheduledCallCreatePopupParams>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useScheduledCallCreatePopupPresenter(props);

    return (
      <Popup
        className={styles.popup}
        headerClassName={styles.popupHeader}
        isShowHeader
        isOpened
        onClose={presenter.onClose}
      >
        <div className={styles.container}>
          <h1 className={styles.title}>{t('сall_has_been_scheduled')}</h1>
          <div className={styles.subTitle}>{presenter.timeText}</div>
          <Button
            onClick={presenter.onDetailsClick}
            theme="primary"
          >
            {t('сall_details')}
          </Button>
        </div>
      </Popup>
    );
  });
